module.exports = __webpack_public_path__ + "static/hero-mobile-33638dce8e4d67e62f4880bebbd5c36e.png";